import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.upload;

const downloadData = createSelector([selector], (state) => state);

export default {
  downloadData
};
